import { render, staticRenderFns } from "./AffiliateIndicationModal.vue?vue&type=template&id=6b7edd98&"
import script from "./AffiliateIndicationModal.vue?vue&type=script&lang=js&"
export * from "./AffiliateIndicationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports